'use strict';

var expandingSectionHeader = $('.experience-commerce_assets-expandingTextSection .text-heading');


$(expandingSectionHeader).on("click", function () {

    var expandingSection = $(this).parent();
    var expandingSectionContent = $(this).next();


    if (!$(expandingSection).hasClass('expanded')) {
        $(expandingSection).addClass('expanded');
    } else {
        $(expandingSection).removeClass('expanded');
    }

    $(expandingSectionContent).slideToggle( "slow", function() {
            //After Slide
      });
});